var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "el-section" }, [
    _c(
      "div",
      {
        staticClass:
          "emd-container _highlight_header _header_spaced _footer_spaced_sm",
      },
      [
        _c("div", { staticClass: "emd-container__header" }, [
          _c("h2", { staticClass: "emd-text _size_section" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("recipients.details.list.bank.title")) + " "
            ),
            _c("span", { staticStyle: { "font-weight": "400" } }, [
              _vm._v(_vm._s(_vm.data.id)),
            ]),
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "h2",
              {
                staticClass: "emd-text _size_section",
                staticStyle: { "margin-right": "5px" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("recipients.details.list.bank.status_list")) +
                    " "
                ),
              ]
            ),
            _c("span", { staticClass: "emd-badge", class: _vm.status }, [
              _vm._v(" " + _vm._s(_vm.data.status_label) + " "),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "emd-table-responsive" },
          [_c("Table", { attrs: { fields: _vm.fields, items: [_vm.data] } })],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }